export default __webpack_public_path__ + "static/media/labor-sub-tier-green.2f7d4dd5.svg";